// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-Auth-styles___pageAuth--E3oCf {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./pages/Auth/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".pageAuth {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageAuth": `pages-Auth-styles___pageAuth--E3oCf`
};
module.exports = ___CSS_LOADER_EXPORT___;
